export default __webpack_public_path__ + "static/media/pagination_right_arrow.9a92990b.svg";